import ComparisonCards from './ComparisonCards';

export default ComparisonCards;
